<script lang="ts" setup>
import { cn } from '~/utils';
import SectionContainer from '~/atoms/layouts/SectionContainer';
import SectionWrapper from '~/atoms/layouts/SectionWrapper';
import Icons from '~/icons/Icons.vue';
import ContentContainer from '~/atoms/layouts/ContentContainer';
import ContentWrapper from '~/atoms/layouts/ContentWrapper';
import SubHeaderWrapper from '~/atoms/layouts/SubHeaderWrapper';

const policiesDocs = [
  {
    header: 'COLLECTION OF PERSONAL INFORMATION',
    sub: [
      {
        title: 'Use and disclosure',
        desc: 'We will only use and disclose your personal information in accordance with applicable ' +
          'privacy laws and this privacy policy.',
      },
      {
        title: 'How we collect Personal Information',
        desc: 'We usually collect personal information as follows:',
        subDesc: [
          'when you access or use our Website, services, content and advertising including ' +
          'when you register or enter your personal details on that Website or enter a ' +
          'competition or participate in a survey;',
          'through other means on our Website, including cookies (see also below), pixel tags, ' +
          'local storage such as browser web storage or application data caches, databases ' +
          'and sever logs;',
          'when you communicate with us through correspondence, chats, email, or when you ' +
          'share information with us from other social applications, services or websites.',
        ],
      },
      {
        title: 'Types of Personal Information we will collect',
        desc: 'The types of personal information we will collect from you will depend on the circumstances' +
          'in which that information is collected. It may include:',
        subDesc: [
          'information you provide to us on our Website or through other websites or accounts ' +
          'from which you permit us to collect information; for example your name, email ' +
          'address, physical address, telephone number and so on;',
          'information you provide to us through customer surveys or in relation to any promotion;',
          'information regarding your use of our Website, including server log information such ' +
          'as when and how you use our Website, what page you visit, links you click on, text ' +
          'or other information entered and mouse or cursor movements;',
          'your device ID, device type, operating system, geo-location information, computer ' +
          'or device hardware and connection information and settings, browser type, browser ' +
          'language, browser ID information, traffic to and from the Website, advertising data ' +
          'and standard web log information;',
          'your IP address.  We may us publicly available sources to approximate your ' +
          'geographic region and internet service provider based on your IP address;',
          'records of our communications and dealings with you, such as emails, SMS, ' +
          'telephone, live chat and in-person communications;',
          'information about which language you speak or communicate in; and',
          'information and opinions about you that are provided by others to us, including ' +
          'banks or regulators.',
        ],
      },
      {
        title: 'Cookies',
        desc: 'We may use cookies to collect the above information.  Cookies are small files that store ' +
          'information on your computer browser, television, mobile or other device.<br>' +
          'We use cookies to help us to improve our site and to deliver a better and more tailored ' +
          'service, for instance, by storing information about your preferences and allowing us to ' +
          'recognize you when you return to our Website.  Please refer below for more information on ' +
          'how we collect and treat cookies.',
      },
      {
        title: 'Collecting information from third parties',
        desc: 'Where practicable, we will collect personal information directly from you.<br>' +
          'However, we may also collect information about you from other people such as a third-' +
          'party administrator or independent sources. For example, if you permit us to ' +
          'access information in other services, such as Facebook or Google Drive, Apple or ' +
          'Dropbox, then we may be able to obtain information from those accounts, depending on ' +
          'your privacy settings.<br>' +
          'If we collect any such third party information, we will hold, use and disclose that information ' +
          'in accordance with this privacy policy.',
      },
      {
        title: 'If you do not provide us with the requested information',
        desc: 'If you do not provide us with the information we request, then we may not be able to fulfil the ' +
          'applicable purposes of collection, such as to supply products or services to you.',
      },
      {
        title: 'Application of the GDPR',
        desc: 'The General Data Protection Regulation (GDPR) applies to the European Union and ' +
          'European Economic Area.  Where applicable, we will comply with the GDPR, including in ' +
          'relation to rectification or deletion of your personal information; processing of that ' +
          'information; unauthorized transfers of that information; transfer of that information to ' +
          'another organization; lodging of complaints; and related matters.',
      },
    ],
  },
  {
    header: 'STORAGE AND SECURITY OF YOUR PERSONAL INFORMATION',
    sub: [
      {
        title: 'Security',
        desc: 'We will take reasonable steps to keep secure any information which we hold about you.',
      },
      {
        title: 'Storage',
        desc: 'Your personal information is stored on secure servers that are protected in controlled facilities ' +
          'that are operated by us or our service providers.',
      },
      {
        title: 'No guarantee',
        desc: 'However,  although  we  will  take  these  steps  to  ensure  the  security  of  your  personal ' +
          'information, we cannot guarantee the security of this information.  For example, your personal ' +
          'information may be compromised as a result of malicious third party cyber attacks or hacking. ' +
          'We do not promise your personal information will remain private and secure.',
      },
      {
        title: 'Transmission',
        desc: 'The transmission of data via the internet is not completely secure. Although we will do ' +
          'our best to protect your personal data, we cannot guarantee the security of your data ' +
          'transmitted to our Website, and any transmission is at your own risk.',
      },
    ],
  },
  {
    header: 'USE OF YOUR PERSONAL INFORMATION',
    sub: [
      {
        title: 'Purposes of collection',
        desc: 'The main purposes for which we collect, hold, use and disclose your personal information ' +
          'are the following:',
        subDesc: [
          'to enable you to access and use our Website, products and services, including to ' +
          'maintain business standards, our operational procedures and systems and security;',
          'to administer surveys, contests, or other promotional activities or events sponsored ' +
          'or managed by us or our business partners;',
          'to gain an understanding of your needs and those of our other customers and ' +
          'potential customers, to provide you and them with better and more personalized ' +
          'products and services tailored to your and their requirements;',
          'to promote and market our services and to assist you in acquiring our services, ' +
          'including by conducting direct marketing activities, such as sending you marketing ' +
          'and promotional messages and other information that may be of interest to you;',
          'to identify you and to consider your eligibility for our products and services;',
          'to respond to enquiries from you or existing or prospective customers seeking ' +
          'information about our services;',
          'to comply with applicable laws to comply with our legal obligations, resolve disputes, ' +
          'and enforce agreements;',
          'for security purposes, including by taking steps we consider reasonably necessary ' +
          'to protect the security and proper functioning of our Website;',
          'to report to our directors and shareholders;',
          'for record keeping; and',
          'to comply with our legal obligations, resolve any disputes that we may have with you or any other person.',
        ],
      },
      {
        title: 'Explanation',
        desc: 'We generally explain at the time we collect personal information how we will use or ' +
          'disclose that information. We will only use or disclose personal information for a purpose ' +
          'other than that for which it was collected or a related purpose if you have consented to ' +
          'such different use or disclosure or such use or disclosure is otherwise allowed by ' +
          'applicable privacy laws.',
      },
    ],
  },
  {
    header: 'DISCLOSURE OF YOUR PERSONAL INFORMATION',
    sub: [
      {
        title: 'How we may disclose your personal information',
        desc: 'We may disclose your personal information as follows:',
        subDesc: [
          'to a person (for example, our consultants, contractors, subcontractors, suppliers, ' +
          'service providers and professional advisors) where we believe this is reasonably necessary to: ' +
          '<div class="mt-4">(i)<span class="pl-4 md:pl-6">' +
          'provide you with a product or service which you have requested;</span></div>' +
          '<div class="mt-4">(ii)<span class="pl-4 md:pl-6">operate our business, for example, ' +
          'by disclosing this personal information to payment service providers, ' +
          'companies that provide identification verification services, customer analytics providers, ' +
          'mail house operators, banks and investigators;</span></div>',
          'to government agencies, regulators and law enforcement bodies;',
          'to insurance companies;',
          'to racing and sporting bodies, but only if you ask us to;',
          'to and between our subsidiaries and our related bodies corporate;',
          'to a court or tribunal or where otherwise required by law, for example in response to ' +
          'a subpoena or other legal document requiring us by law to produce or disclose ' +
          'information or documents about you to them; and',
          'to a person who acquires (or is considering acquiring) the assets and operations of our business.',
        ],
      },
      {
        title: 'Third party service providers',
        desc: 'Personal information or data that we collect about you may be stored or otherwise ' +
          'processed by third party services with data centres based outside your jurisdiction, such as ' +
          'Amazon Web Services, Apple, Google Analytics, Microsoft Azure and the like, or other online relationship ' +
          'management tools.  We consider that the collection and such processing of this information:',
        subDesc: [
          'is necessary to pursue our legitimate interests in a way that might reasonably be  expected, ' +
          'including in order to analyse how you and our other customers use our services and develop ' +
          'our services and business; and',
          'does not materially impact your rights, freedom or interests.',
        ],
        extraDesc: 'We require that all third parties who act as “data processors” for us provide sufficient ' +
          'guarantees and implement appropriate technical and organisational measures to secure your data; ' +
          'only process personal data for specified purposes; and have provided binding confidentiality commitments.',
      },
      {
        title: 'Sharing of information',
        desc: 'Otherwise, we would not otherwise routinely disclose your personal information to another ' +
          'person or organisation unless:',
        subDesc: [
          'it is necessary to protect the rights, property or personal safety of you or any of our' +
          'customers, any member of the public or our interests; or',
          'you have provided your consent.',
        ],
      },
      {
        title: 'Disclosure outside your jurisdiction',
        desc: 'We may disclose personal information outside of your jurisdiction, for example to countries in ' +
          'which we operate or as described elsewhere in this privacy policy.  The privacy laws in these ' +
          'countries may not provide the same level of protection as those in your jurisdiction.',
      },
      {
        title: 'Commitment to your privacy',
        desc: 'However, this does not change our commitment to safeguard your privacy and we will comply ' +
          'with all applicable laws relating to the cross-border disclosure of data.',
      },
    ],
  },
  {
    header: 'MARKETING',
    sub: [
      {
        title: 'Marketing',
        desc: 'We may use and disclose your personal information to carry out consumer, market, ' +
          'community and product research, compile demographics and perform other analysis so that ' +
          'we can develop and implement initiatives to improve our products and services.',
      },
      {
        title: 'Direct marketing',
        desc: 'We may send marketing communications (for example, email or other forms of direct ' +
          'messaging or social media messaging) and materials to you and other current or ' +
          'prospective customers.  We only do so in accordance with applicable laws or with your prior consent.',
      },
      {
        title: 'Opt out',
        desc: 'If you are receiving promotional information from us and do not wish to receive this ' +
          'information any longer, please either:',
        subDesc: [
          'unsubscribe by following the link or instructions in our marketing communication; or',
          'contact <a class="text-blue-600" href="mailto:support@junglebet.com">support@junglebet.com</a> ' +
          'asking to be removed from our mailing lists.',
        ],
      },
      {
        title: 'Google and Facebook',
        desc: 'We may use the Google AdWords or Facebook re-marketing services to advertise to you on ' +
          'third party platforms, based upon your activity on this Website.  This advertising may be displayed on:',
        subDesc: [
          'a Google search results page or in the Google Display Network; or',
          'inside Facebook.',
        ],
        extraDesc: 'Google and Facebook may use cookies or pixel tags for this purpose. Any data which is collected ' +
          'by Google and/or Facebook will be used in accordance with their own respective privacy policies.',
      },
    ],
  },
  {
    header: 'OUR WEBSITE PRIVACY PRACTICES',
    sub: [
      {
        title: 'Cookies',
        desc: 'We use cookie technology on the Website to provide information and services to visitors. ' +
          'Cookies are pieces of information that a website transfers to your computer\'s hard disk for ' +
          'record keeping purposes and are a necessary part of facilitating online transactions. Most web ' +
          'browsers are set to accept cookies.',
      },
      {
        title: 'Refusal of cookies',
        desc: 'If you do not wish to receive any cookies you may set your browser to refuse cookies. This ' +
          'may mean you will not be able to take full advantage of the services on the Website.',
      },
    ],
  },
  {
    header: 'LINKS TO OTHER WEBSITES',
    sub: [
      {
        title: 'Links',
        desc: 'Our Website may contain links to third party websites. These linked sites are not under our ' +
          'control and we are not responsible for the content of those sites nor are those sites subject ' +
          'to this privacy policy.',
      },
      {
        title: 'Other websites',
        desc: 'Before disclosing your personal information on any other website (including one linked to ' +
          'from our Website) we recommend that you examine the terms and conditions and privacy ' +
          'policy of the relevant site. We are not responsible for any practices on linked websites that ' +
          'might breach your privacy.',
      },
    ],
  },
  {
    header: 'EMPLOYEE INFORMATION',
    sub: [
      {
        title: 'Not applicable to employees',
        desc: 'This privacy policy does not apply to the handling of information about our employees or ' +
          'past employees.',
      },
    ],
  },
  {
    header: 'ACCESSING TO YOUR PERSONAL INFORMATION',
    sub: [
      {
        title: 'Maintenance',
        desc: 'We will take reasonable steps to ensure the personal information we hold about you is ' +
          'accurate, complete, up-to-date, relevant, and not misleading.',
      },
      {
        title: 'You may request access to your personal information',
        desc: 'You have the right to access, update and correct the personal information that we hold about you. ' +
          'If at any time you want to know exactly what personal information we hold about you, ' +
          'then you may request access to your record by contacting us at ' +
          '<a class="text-blue-600" href="mailto:support@junglebet.com">support@junglebet.com</a>',
        subDesc: [
          'we may need to request further information from you, for example to verify your identity;',
          'where we are reasonably able to do so, we will provide you with a copy of your ' +
          'personal information within a reasonable period after the request is made, usually ' +
          'within thirty (30) days.  In some cases, we may not be able to provide you with ' +
          'access to all of your personal information.  In this case we will explain the reasons for this;',
          'where permitted by law to do so, we may charge a reasonable fee to provide access to your ' +
          'personal information, but we will not charge you a fee to make a request. If we intend to charge ' +
          'you a fee, then we will advise you of this fee before we provide access.',
        ],
      },
      {
        title: 'Request to change your personal information',
        desc: 'If at any time you wish to change personal information that we hold about you because it is ' +
          'inaccurate or out of date, please contact us at ' +
          '<a class="text-blue-600" href="mailto:support@junglebet.com">support@junglebet.com</a> ' +
          'and we will amend this record.<br>If you wish to have your personal information deleted, ' +
          'please let us know in the same manner as referred to above and we will take all reasonable steps ' +
          'to delete it unless we need to keep it for legal reasons or otherwise as permitted by applicable law.',
      },
      {
        title: 'Withdrawal of consent',
        desc: 'If you wish to access, rectify, erase, restrict, port or otherwise object to the processing of ' +
          'your personal information, or choose to withdraw your consent to this processing, we will ' +
          'give effect that decision where required to do so by the GDPR or other applicable laws. In ' +
          'this case please be aware that this may mean we cannot provide our products and services ' +
          'to you in as originally contemplated or at all.',
      },
    ],
  },
  {
    header: 'RETENTION OF INFORMATION',
    sub: [
      {
        title: 'Retention',
        desc: 'We will only keep your personal information for as long as is necessary for the purpose ' +
          'for which it was collected, subject to meeting our legal, accounting and reporting requirements.',
      },
      {
        title: 'Following the retention period',
        desc: 'At the end of this retention period, we will either delete or anonymise your data; for ' +
          'example, by aggregating that data with other data so that it can be used in a non-identifiable ' +
          'way for statistical analysis and business planning.',
      },
    ],
  },
  {
    header: 'CONTACTING US',
    sub: [
      {
        title: 'Concerns',
        desc: 'If you have any concerns or complaints about how we handle your personal information, or ' +
          'if you have any questions about this privacy policy, then please contact us at: ' +
          '<a class="text-blue-600" href="mailto:support@junglebet.com">support@junglebet.com</a>.',
      },
      {
        title: 'Investigation',
        desc: 'In most cases we will ask that you put your request in writing to us. We will investigate your ' +
          'complaint and will use our reasonable endeavours to respond to you in writing within thirty ' +
          '30 days of receiving the written complaint.',
      },
      {
        title: 'Failure to respond',
        desc: 'If we fail to respond to your complaint within a reasonable period of receiving it in writing or if ' +
          'you are dissatisfied with the response that you receive from us, you may have the right, depending ' +
          'on applicable law, to make a complaint to a privacy regulatory authority.',
      },
    ],
  },
  {
    header: 'FUTURE CHANGES',
    sub: [
      {
        title: 'Changes to this policy',
        desc: 'We operate in a continually changing business environment. Over time, aspects of our ' +
          'business may change as we respond to changing market conditions. This may require our ' +
          'policies to be reviewed and revised. We reserve the right to change this privacy policy at any ' +
          'time and notify you by posting an updated version of the policy on the Website.',
      },
      {
        title: 'Different use',
        desc: 'If at any time we decide to use personal information in a manner materially different from that ' +
          'stated at the time it was collected we will notify users by email or via a prominent notice on ' +
          'our Website, and where necessary we will seek the prior consent of our users.',
      },
    ],
  },
  {
    header: 'OTHER MATTERS',
    sub: [
      {
        title: 'Severability',
        desc: 'Any provision of this privacy policy which is void or unenforceable may be severed from this ' +
          'Policy without affecting the enforceability of other provisions.',
      },
      {
        title: 'Waiver',
        desc: 'Any failure or delay by us to enforce or exercise a power or right or provisions of this privacy ' +
          'policy is not a waiver of those rights or provisions.  The exercise by us of any right or power ' +
          'under this privacy policy does not preclude our ability to exercise that or any other right or ' +
          'power in the future. ',
      },
    ],
  },
];

const subDisc = ['(a)', '(b)', '(c)', '(d)', '(e)', '(f)', '(g)', '(h)', '(i)', '(j)', '(k)'];

useSeoMeta({
  title: 'Privacy Policy',
});
</script>

<template>
  <SectionContainer>
    <SectionWrapper>
      <ContentContainer>
        <ContentWrapper
          :class="cn('flex flex-col justify-center gap-5 md:gap-[43px]')"
        >
          <SubHeaderWrapper
            :class="cn('mt-4 md:mt-[34px] flex-wrap')"
          >
            <h1 class="text-xxl md:text-xxxl font-bold w-full">
              JUNGLEBET.COM | PRIVACY POLICY
            </h1>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              This privacy policy applies to Deveron LLC trading as Junglebet.com (<strong>"we", "us", "our"</strong>)
              and its affiliates in relation to their operations.
            </p>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              This privacy policy applies to the ‘free spin’ landing page for Junglebet.com found at: junglebet.com
              (Website). It does not apply to third party web sites and apps which may be linked to from our Website.
            </p>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              By using our Website and providing personal information to us, you consent to us collecting, using,
              storing and disclosing your personal information in accordance with this privacy policy and any other
              arrangements that apply between us.
            </p>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              This privacy policy describes:
            </p>

            <ul
              class="
                text-zinc-100 font-normal text-md md:text-lg col-span-11
                leading-none w-full mt-2 md:mt-4 list-disc pl-4
              "
            >
              <li>
                what information about persons we collect, including information or an opinion about an
                individual whose identity is reasonably identifiable (<strong>personal information</strong>);
              </li>
              <li class="mt-2 md:mt-4">
                how we handle and store this personal information;
              </li>
              <li class="mt-2 md:mt-4">
                how and to whom we disclose this personal information; and
              </li>
              <li class="mt-2 md:mt-4">
                how we comply with applicable privacy laws (<strong>privacy laws</strong>) and related matters.
              </li>
            </ul>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              We may change this privacy policy from time to time by publishing changes to it on the Website. We
              encourage you to check the Website periodically to ensure that you are aware of our current privacy
              policy.
            </p>

            <p
              class="
                text-zinc-100 font-normal text-md md:text-lg
                col-span-11 leading-none w-full mt-2 md:mt-4
              "
            >
              If you have further questions relating to this Privacy Policy, please contact us at
              <a
                class="text-blue-600"
                href="mailto:support@junglebet.com"
              >support@junglebet.com</a>.
            </p>
          </SubHeaderWrapper>
          <div
            :class="cn('w-full max-w-[338px] md:max-w-[1011px] mx-auto pb-12')"
          >
            <ol class="list-decimal text-highlights text-lg md:text-xl">
              <li
                v-for="(policy, t) in policiesDocs"
                :key="t"
                class="mt-2 md:mt-4"
              >
                <h2 class="underline font-bold text-lg md:text-2xl mb-2 mb:mb-4 pl-2 md:pl-4">
                  {{ policy.header }}
                </h2>

                <ol class="text-paragraph">
                  <li
                    v-for="(subItem, s) in policy.sub"
                    :key="s"
                    class="mt-2 md:mt-4"
                  >
                    <h3 class="text-lg md:text-xl grid grid-cols-12">
                      <span class="col-span-1">{{ (t + 1) }}.{{ (s + 1) }}</span>
                      <span class="font-semibold col-span-11">{{ subItem.title }}</span>
                    </h3>

                    <div class="grid grid-cols-12">
                      <div class="col-span-1" />
                      <p
                        class="
                          text-zinc-100 font-normal text-md md:text-lg
                          col-span-11 leading-none
                        "
                        v-html="subItem.desc"
                      />
                    </div>

                    <div
                      v-if="subItem.subDesc"
                      class="grid grid-cols-12"
                    >
                      <div class="col-span-1" />
                      <ol
                        v-if="subItem.subDesc"
                        class="text-zinc-100 font-normal text-md md:text-lg col-span-11"
                      >
                        <li
                          v-for="(sItem, sI) in subItem.subDesc"
                          :key="sI"
                          class="mt-2 md:mt-4 grid grid-cols-12"
                        >
                          <span class="col-span-1 leading-none">{{ subDisc[sI] }}</span>
                          <span
                            class="col-span-11 leading-none"
                            v-html="sItem"
                          />
                        </li>
                      </ol>
                    </div>

                    <div
                      v-if="subItem.extraDesc"
                      class="grid grid-cols-12"
                    >
                      <div class="col-span-1" />
                      <p
                        class="
                          text-zinc-100 font-normal text-md md:text-lg
                          col-span-11 mt-2 md:mt-4 leading-none
                        "
                        v-html="subItem.extraDesc"
                      />
                    </div>
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </ContentWrapper>
      </ContentContainer>
    </SectionWrapper>

    <Icons :class="cn('absolute bottom-0 left-0')" />
  </SectionContainer>
</template>
